'use client';
import { jsx } from '@emotion/react/jsx-runtime';
import { forwardRef } from 'react';
import { SvgIcon } from '@s7/base';

function _extends() {
    _extends = Object.assign || function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source){
                if (Object.prototype.hasOwnProperty.call(source, key)) {
                    target[key] = source[key];
                }
            }
        }
        return target;
    };
    return _extends.apply(this, arguments);
}
const MilesItalicSemiBold = /*#__PURE__*/ forwardRef((props, ref)=>/*#__PURE__*/ jsx(SvgIcon, _extends({
        fill: "none",
        height: 72,
        viewBox: "0 0 72 72",
        width: 72
    }, props, {
        ref: ref,
        children: /*#__PURE__*/ jsx("path", {
            clipRule: "evenodd",
            d: "M25.7613 30.5299L21.4529 53.5078H15.8702L18.2576 40.75H8.75L9.76953 35.25H19.2868L22.4677 18.251H28.4057L34.8372 44.4059L50.7017 18.251H57.0636L53.8763 35.25H63.25L62.2227 40.75H52.845L50.4529 53.5078H44.8413L48.9323 31.7734L36.1013 52.9272H31.1927L25.7613 30.5299Z",
            fill: "currentColor",
            fillRule: "evenodd"
        })
    })));

export { MilesItalicSemiBold };
//# sourceMappingURL=MilesItalicSemiBold.js.map
